// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d5aa52a6","88":"3fad99b8","126":"ea95e0d2","277":"dafd7e87","577":"bf74e777","614":"3ce3341d","624":"fcf19d82","703":"893ac51a","739":"ab95eafb","789":"40bed246","953":"3d2533f0","957":"96efdc7b","987":"e883f664"}[chunkId] + ".chunk.js";
};